export default {
    data() {
        return {
            infoText: null,
            permanentInfoText: null,
        };
    },
    mounted() {
        this.$eventBus.$on('info-show', (infoKeyword, fromInfoList) => {
            this.showInfo(infoKeyword, fromInfoList);
        });
        this.$eventBus.$on('info-remove', (infoKeyword) => {
            this.hideInfo();
        });
    },
    methods: {
        showInfo(infoKeyword, fromInfoList = true) {
            let infoText = fromInfoList ? this.__(`explanations.${infoKeyword}`) : infoKeyword;

            let keywords = infoText.match(/{{(.*?)}}/g);

            keywords = _.uniq(keywords);

            let keywordsToReplace = {};

            keywords.forEach((keyword) => {
                keyword = keyword.replace('{{', '').replace('}}', '').trim();

                const translation = this.__(`explanations.tips.${keyword}`);

                keywordsToReplace[`{{${keyword}}}`] = ` data-toggle="tooltip" data-placement="top" title="${translation}" `
            });

            _.forEach(keywordsToReplace, (text, keyword) => {
                infoText = infoText.replaceAll(keyword, text);
            });

            this.infoText = infoText;

            this.$nextTick(() => {
                $('[data-toggle="tooltip"]').tooltip();
            });

            this.adjustInfoBox();
        },
        hideInfo() {
            this.infoText = null;
        }
    }
};
